export const toDollars = (amount = 0) => {
    return (amount / 100).toFixed(2);
};
